import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Hero, About, Skills, Services, Portfolio, Experience, Education, Contact } from "./components/Sections";
import { Toaster } from "./components/ui/toaster";
import AdminProjects from "./pages/AdminProjects";
import ProjectDetail from "./pages/ProjectDetail";
import AdminGuard from "./components/AdminGuard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    const helloWorldApi = async () => {
      try {
        const response = await axios.get(`${API}/`);
        console.log("Backend says:", response.data.message);
      } catch (e) {
        console.warn("Backend hello check failed (this is okay for mock stage):", e?.message || e);
      }
    };
    helloWorldApi();
  }, []);

  return (
    <div className="min-h-screen bg-white text-slate-800">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <About />
                <Skills />
                <Services />
                <Portfolio />
                <Experience />
                <Education />
                <Contact />
              </>
            } />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/admin" element={<AdminGuard><AdminProjects /></AdminGuard>} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;